import {
    Component,
    ContentChildren,
    Directive,
    Input,
    QueryList,
    AfterContentInit,
    AfterContentChecked
} from '@angular/core';

import { NgbTabTitleDirective, NgbTabContentDirective } from './ngb-tab.directive';

let nextId = 0;
@Component({
    selector: 'ngb-tab',
    template: '',
    standalone: false
})
export class NgbTabComponent  implements AfterContentChecked {
 private _id!: string;

  @Input()
  set id(val: string) {
    this._id = val;
  }

  get id(): string {
    if (!this._id) {
      this._id = `ngb-tab-${nextId++}`;
    }
    return this._id;
  }

  @Input() title?: string;
  @Input() disabled = false;

  contentTpl?: NgbTabContentDirective;
  customTitleTpl?: NgbTabTitleDirective;

  @ContentChildren(NgbTabContentDirective, { descendants: true })
  private contentTpls!: QueryList<NgbTabContentDirective>;

  @ContentChildren(NgbTabTitleDirective, { descendants: true })
  private titleTpls!: QueryList<NgbTabTitleDirective>;

  ngAfterContentChecked() {
    // Se fait à chaque vérification pour récupérer les templates même projetés tardivement
    this.contentTpl = this.contentTpls.first;
    this.customTitleTpl = this.titleTpls.first;
  }
}